import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconPrescribers from 'components/icons/IconPrescribers';

const styles = () => ({
  root: {
    minHeight: 330,
  },
  iconPrescribers: {
    width: 90,
    height: 100,
  },
});

const PrescribersSearchDialogListEmpty = ({ submitSucceeded, classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconPrescribers className={classes.iconPrescribers} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        {submitSucceeded
          ? 'Unfortunately, there are no such prescribers in registry'
          : 'Please, specify First and Last Name or NPI to search prescribers'}
      </Typography>
    </Grid>
  </Grid>
);

PrescribersSearchDialogListEmpty.propTypes = {
  submitSucceeded: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconPrescribers: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PrescribersSearchDialogListEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersSearchDialog/PrescribersSearchDialogListEmpty.js